/* unplugin-vue-components disabled */import script from "./PocketPropsHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./PocketPropsHeader.vue?vue&type=script&setup=true&lang=js"

import "./PocketPropsHeader.vue?vue&type=style&index=0&id=91f8211a&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91f8211a"]])

export default __exports__